export enum ProjectsTypesNames {
  EPCM = 'epcm',
  RE2020 = 're2020',
  NOOCO = 'nooco',
  EXPLOITATION = 'exploitation',
  AIRPORT = 'airport',
  DATACENTER = 'datacenter',
  OUTDOOR = 'outdoor',
  RENOVATION = 'renovation',
  MAPPINGREF = 'mappingRef',
  PROTOTYPE = 'prototype',
  BBCA = 'bbca',
  SIMULATOR = 'quickSim',
  GLOBAL_MONITORING = 'globalMonitoring',
};

